import React from 'react';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { message } from 'antd';

// Create a client
export const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error) => {
            message.error(`Api Error`, error);
        },
    }),
    mutationCache: new MutationCache({
        onError: (error) => {
            message.error(`Api Error`, error);
        },
    }),
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

export function ApiQueryClientProvider({ children }) {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
